import type { FAQItem } from "@/lib/products";

/**
 * FAQ data for the Chrome Extension Icon Resizer tool
 * Separated from view layer for maintainability
 */
export const extensionIconResizerFAQ: FAQItem[] = [
  {
    question: "What image formats are supported?",
    answer:
      "The tool supports PNG and JPG/JPEG image formats. We recommend using PNG for icons as it supports transparency, which is important for Chrome extension icons. Upload any square image (512x512px or larger recommended) and we'll generate all required sizes.",
  },
  {
    question: "What icon sizes are generated?",
    answer:
      "The tool automatically generates four standard Chrome extension icon sizes: 16x16 pixels (for the browser toolbar), 32x32 pixels (for Windows), 48x48 pixels (for the extension management page), and 128x128 pixels (for the Chrome Web Store). All icons are included in a single ZIP file for easy download.",
  },
  {
    question: "What size should my source image be?",
    answer:
      "We recommend uploading a square image that's at least 512x512 pixels for best quality. Larger images (1024x1024 or 2048x2048) will produce even sharper results. The tool uses high-quality image resizing algorithms to ensure your icons look crisp at all sizes, even when downscaled from a large source image.",
  },
  {
    question: "Is my image uploaded to your servers?",
    answer:
      "No. All image processing happens entirely in your browser using JavaScript. Your image never leaves your device—we don't upload, store, or access your files. This ensures complete privacy and security for your work. The ZIP file is also generated locally in your browser.",
  },
  {
    question: "Can I use transparent backgrounds?",
    answer:
      "Yes! PNG images with transparency are fully supported. The tool preserves transparency when generating all icon sizes, which is essential for Chrome extension icons that need to look good on different browser themes and backgrounds. Make sure your source image is a PNG with transparency if you want transparent icons.",
  },
  {
    question: "How do I use the generated icons in my extension?",
    answer:
      "After downloading the ZIP file, extract it to get the four icon files (icon-16.png, icon-32.png, icon-48.png, icon-128.png). Add these files to your extension's directory, then reference them in your manifest.json file under the 'icons' field. The Chrome Web Store will automatically use the 128x128 icon, while the browser uses the other sizes as needed.",
  },
  {
    question: "Do I need to pay to use this tool?",
    answer:
      "No, this tool is completely free to use with no limits. You can generate as many icon sets as you need, as often as you want. There's no registration required, no watermarks, and no hidden fees. It's part of our free tools collection to help developers build better Chrome extensions faster.",
  },
  {
    question: "What if my icons look blurry after resizing?",
    answer:
      "If your icons appear blurry, try using a higher-resolution source image (1024x1024 or larger). The tool uses high-quality image smoothing algorithms, but starting with a larger, sharper source image will always produce better results. Also ensure your source image is a square (equal width and height) for best results.",
  },
];
